import { useTranslation } from 'react-i18next';

import BrandLogo from '@/assets/icons/BrandLogo.svg?react';
import BrandLogoMobile from '@/assets/icons/brandLogoMobile.svg?react';
import CustomerAreaLogo from '@/assets/icons/customerAreaLogo.svg?react';
import CustomerAreaLogoMobile from '@/assets/icons/customerAreaLogoMobile.svg?react';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { URLS } from '@/constants/urls';
import useScreenSize from '@/hooks/useScreenSize';

import style from './styles.module.css';

export const HeaderNotConnected = () => {
  const { windowWidth } = useScreenSize();
  const { t } = useTranslation();
  return (
    <div className={style.topHeaderNotConnected}>
      {windowWidth > BREAKPOINTS.tablet ? (
        <>
          <div className={style.logos}>
            <a href={URLS.MTP_URL}>
              <BrandLogo width={300} height={44} aria-label="logo meilleurtaux" />
            </a>
            <div className={style.customerLogo}>
              <CustomerAreaLogo width={200} height={58} aria-label="logo espace client" />
            </div>
          </div>

          <a className={style.contact} href={URLS.MTP_CONTACT_URL} tabIndex={0}>
            <span className={style.phoneNumber}>{t('navigation.phoneNumber')}</span>
            <p className={style.descriptionContact}>{t('navigation.infoService')}</p>
          </a>
        </>
      ) : (
        <div className={style.logos}>
          <a href={URLS.MTP_URL}>
            <BrandLogoMobile width={65} height={42} aria-label="logo meilleurtaux" />
          </a>
          <div className={style.customerLogo}>
            <CustomerAreaLogoMobile width={150} height={40} aria-label="logo espace client" />
          </div>
        </div>
      )}
    </div>
  );
};
